import React from 'react';
import { Flex } from '../../../components/Flex/Flex';
import Icons from '../../../../public/assets/icons';
import { useBuscaContext } from '../../../providers/BuscaProvider/BuscaProvider';
import { format, parse } from 'date-fns';
import {
  TabOptions,
  Trip,
  tabOptionValue
} from '../../../interfaces/Fretamento/fretamento';
import { ptBR } from 'date-fns/locale/pt-BR';
import { useRoteiro } from '../../../providers/RoteiroPersonalizadoProvider/RoteiroPersonalizadoContext';
import {
  RoteiroPersonalizadoResumoDestino,
  RoteiroPersonalizadoResumoOrigem
} from '../../Trajeto/RoteiroPersonalizado/Resumo/RoteiroPersonalizadoResumoCards';

interface Props {
  trip?: Trip;
  type?: TabOptions;
}

const BuscarVeiculoModalOrigem = ({ trip }: Props) => {
  const { busca } = useBuscaContext();
  const mapping = trip ? trip.stopPoints : busca.embarques;

  const date = trip?.origin?.date || busca?.origem?.date;
  const originDate = date
    ? format(parse(date, 'yyyy/MM/dd', new Date()), "d 'de' MMMM, yyyy", {
        locale: ptBR
      })
    : undefined;

  const originTime = trip?.origin.time || busca?.origem?.time;

  return (
    <Flex className="w-full gap-4 min-h-[140px] lg:min-h-[120px]">
      <Flex direction="col" className="w-6 items-center min-w-6">
        <Flex className="w-6 h-6">
          <Icons.BlueBus className="text-[color:var(--text-primary-pure)] w-6 h-6" />
        </Flex>
        <div className="w-1 h-full bg-neutral-pure300 rounded-[10px]" />
      </Flex>
      <Flex className="w-full gap-1 flex-col">
        <p className="h5 text-neutral-pure1000">Origem</p>
        <Flex className="flex-col gap-2">
          <Flex className="items-center gap-1.5 bodysm text-neutral-pure800">
            <div className="min-w-4 w-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
              >
                <g clipPath="url(#clip0_374_10090)">
                  <path
                    d="M6 7.83398C6 8.36442 6.21071 8.87313 6.58579 9.2482C6.96086 9.62327 7.46957 9.83398 8 9.83398C8.53043 9.83398 9.03914 9.62327 9.41421 9.2482C9.78929 8.87313 10 8.36442 10 7.83398C10 7.30355 9.78929 6.79484 9.41421 6.41977C9.03914 6.0447 8.53043 5.83398 8 5.83398C7.46957 5.83398 6.96086 6.0447 6.58579 6.41977C6.21071 6.79484 6 7.30355 6 7.83398Z"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M11.7717 11.6045L8.94299 14.4331C8.69298 14.6829 8.35405 14.8232 8.00066 14.8232C7.64727 14.8232 7.30834 14.6829 7.05833 14.4331L4.22899 11.6045C3.48314 10.8586 2.97522 9.90827 2.76945 8.87371C2.56369 7.83916 2.66932 6.76681 3.073 5.79229C3.47667 4.81777 4.16026 3.98483 5.03732 3.39881C5.91437 2.81279 6.94551 2.5 8.00033 2.5C9.05515 2.5 10.0863 2.81279 10.9633 3.39881C11.8404 3.98483 12.524 4.81777 12.9277 5.79229C13.3313 6.76681 13.437 7.83916 13.2312 8.87371C13.0254 9.90827 12.5175 10.8586 11.7717 11.6045Z"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_374_10090">
                    <rect
                      width="16"
                      height="16"
                      fill="white"
                      transform="translate(0 0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <p className="text-neutral-pure800 font-[500]">
              {trip?.origin.address || busca.origem.address}
            </p>
          </Flex>
          {mapping?.map((ponto) => (
            <>
              {!!ponto?.address && (
                <Flex
                  key={ponto.lat}
                  className="mb-1 items-center gap-1.5 bodysm text-neutral-pure800"
                >
                  <Icons.Embarque className="w-4 h-4 text-[color:var(--text-primary-pure)]" />
                  <p className="text-neutral-pure800 font-[600]">
                    {ponto.address}
                  </p>
                </Flex>
              )}
            </>
          ))}
          <Flex className="items-center gap-1.5 bodysm text-neutral-pure800">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
            >
              <g clipPath="url(#clip0_374_10096)">
                <path
                  d="M2.66699 5.16732C2.66699 4.8137 2.80747 4.47456 3.05752 4.22451C3.30756 3.97446 3.6467 3.83398 4.00033 3.83398H12.0003C12.3539 3.83398 12.6931 3.97446 12.9431 4.22451C13.1932 4.47456 13.3337 4.8137 13.3337 5.16732V13.1673C13.3337 13.5209 13.1932 13.8601 12.9431 14.1101C12.6931 14.3602 12.3539 14.5007 12.0003 14.5007H4.00033C3.6467 14.5007 3.30756 14.3602 3.05752 14.1101C2.80747 13.8601 2.66699 13.5209 2.66699 13.1673V5.16732Z"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M10.667 2.5V5.16667"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M5.33301 2.5V5.16667"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M2.66699 7.83398H13.3337"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M4.66699 9.83398H4.67566"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6.67285 9.83398H6.67618"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M8.67285 9.83398H8.67618"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M10.6768 9.83398H10.6801"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M8.67676 11.834H8.68009"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M4.67285 11.834H4.67618"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6.67285 11.834H6.67618"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_374_10096">
                  <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(0 0.5)"
                  />
                </clipPath>
              </defs>
            </svg>
            {originDate && (
              <p className="text-neutral-pure800 font-[500]">{originDate}</p>
            )}
          </Flex>
          <Flex className="items-center gap-1.5 bodysm text-neutral-pure800">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
            >
              <g clipPath="url(#clip0_374_10111)">
                <path
                  d="M2 8.5C2 9.28793 2.15519 10.0681 2.45672 10.7961C2.75825 11.5241 3.20021 12.1855 3.75736 12.7426C4.31451 13.2998 4.97595 13.7417 5.7039 14.0433C6.43185 14.3448 7.21207 14.5 8 14.5C8.78793 14.5 9.56815 14.3448 10.2961 14.0433C11.0241 13.7417 11.6855 13.2998 12.2426 12.7426C12.7998 12.1855 13.2417 11.5241 13.5433 10.7961C13.8448 10.0681 14 9.28793 14 8.5C14 7.71207 13.8448 6.93185 13.5433 6.2039C13.2417 5.47595 12.7998 4.81451 12.2426 4.25736C11.6855 3.70021 11.0241 3.25825 10.2961 2.95672C9.56815 2.65519 8.78793 2.5 8 2.5C7.21207 2.5 6.43185 2.65519 5.7039 2.95672C4.97595 3.25825 4.31451 3.70021 3.75736 4.25736C3.20021 4.81451 2.75825 5.47595 2.45672 6.2039C2.15519 6.93185 2 7.71207 2 8.5Z"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M8 8.5L9.33333 10.5"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M8 5.16602V8.49935"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_374_10111">
                  <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(0 0.5)"
                  />
                </clipPath>
              </defs>
            </svg>
            {originTime && (
              <p className="text-neutral-pure800 font-[500]">
                Saída às {originTime}
              </p>
            )}
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};
const BuscarVeiculoModalDestino = ({ trip, type }: Props) => {
  const { busca } = useBuscaContext();

  const date = trip?.destination?.date || busca?.destino?.date;
  const destinationDate = date
    ? format(parse(date, 'yyyy/MM/dd', new Date()), "d 'de' MMMM, yyyy", {
        locale: ptBR
      })
    : undefined;

  const destinationTime = trip?.destination.time || busca?.destino?.time;

  return (
    <Flex className="w-full gap-4 min-h-[140px] lg:min-h-[120px]">
      <Flex direction="col" className="w-6 items-center min-w-6">
        <Flex className="w-6 h-6">
          <Icons.BlueMapPin className="text-[color:var(--text-primary-pure)] w-6 h-6" />
        </Flex>
      </Flex>
      <Flex className="w-full gap-1 flex-col">
        <p className="h5 text-neutral-pure1000">Destino</p>
        <Flex className="flex-col gap-2">
          <Flex className="items-center gap-1.5 bodysm text-neutral-pure800">
            <div className="min-w-4 w-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
              >
                <g clipPath="url(#clip0_374_10090)">
                  <path
                    d="M6 7.83398C6 8.36442 6.21071 8.87313 6.58579 9.2482C6.96086 9.62327 7.46957 9.83398 8 9.83398C8.53043 9.83398 9.03914 9.62327 9.41421 9.2482C9.78929 8.87313 10 8.36442 10 7.83398C10 7.30355 9.78929 6.79484 9.41421 6.41977C9.03914 6.0447 8.53043 5.83398 8 5.83398C7.46957 5.83398 6.96086 6.0447 6.58579 6.41977C6.21071 6.79484 6 7.30355 6 7.83398Z"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M11.7717 11.6045L8.94299 14.4331C8.69298 14.6829 8.35405 14.8232 8.00066 14.8232C7.64727 14.8232 7.30834 14.6829 7.05833 14.4331L4.22899 11.6045C3.48314 10.8586 2.97522 9.90827 2.76945 8.87371C2.56369 7.83916 2.66932 6.76681 3.073 5.79229C3.47667 4.81777 4.16026 3.98483 5.03732 3.39881C5.91437 2.81279 6.94551 2.5 8.00033 2.5C9.05515 2.5 10.0863 2.81279 10.9633 3.39881C11.8404 3.98483 12.524 4.81777 12.9277 5.79229C13.3313 6.76681 13.437 7.83916 13.2312 8.87371C13.0254 9.90827 12.5175 10.8586 11.7717 11.6045Z"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_374_10090">
                    <rect
                      width="16"
                      height="16"
                      fill="white"
                      transform="translate(0 0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <p className="text-neutral-pure800 font-[500]">
              {trip?.destination.address || busca.destino.address}
            </p>
          </Flex>
          <Flex className="items-center gap-1.5 bodysm text-neutral-pure800">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
            >
              <g clipPath="url(#clip0_374_10096)">
                <path
                  d="M2.66699 5.16732C2.66699 4.8137 2.80747 4.47456 3.05752 4.22451C3.30756 3.97446 3.6467 3.83398 4.00033 3.83398H12.0003C12.3539 3.83398 12.6931 3.97446 12.9431 4.22451C13.1932 4.47456 13.3337 4.8137 13.3337 5.16732V13.1673C13.3337 13.5209 13.1932 13.8601 12.9431 14.1101C12.6931 14.3602 12.3539 14.5007 12.0003 14.5007H4.00033C3.6467 14.5007 3.30756 14.3602 3.05752 14.1101C2.80747 13.8601 2.66699 13.5209 2.66699 13.1673V5.16732Z"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M10.667 2.5V5.16667"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M5.33301 2.5V5.16667"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M2.66699 7.83398H13.3337"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M4.66699 9.83398H4.67566"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6.67285 9.83398H6.67618"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M8.67285 9.83398H8.67618"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M10.6768 9.83398H10.6801"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M8.67676 11.834H8.68009"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M4.67285 11.834H4.67618"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6.67285 11.834H6.67618"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_374_10096">
                  <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(0 0.5)"
                  />
                </clipPath>
              </defs>
            </svg>
            {destinationDate && (
              <p className="text-neutral-pure800 font-[500]">
                {destinationDate}
              </p>
            )}
          </Flex>
          {type
            ? type !== 'onewaytrip'
            : busca.type !== 'onewaytrip' && (
                <Flex className="items-center gap-1.5 bodysm text-neutral-pure800">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_374_10111)">
                      <path
                        d="M2 8.5C2 9.28793 2.15519 10.0681 2.45672 10.7961C2.75825 11.5241 3.20021 12.1855 3.75736 12.7426C4.31451 13.2998 4.97595 13.7417 5.7039 14.0433C6.43185 14.3448 7.21207 14.5 8 14.5C8.78793 14.5 9.56815 14.3448 10.2961 14.0433C11.0241 13.7417 11.6855 13.2998 12.2426 12.7426C12.7998 12.1855 13.2417 11.5241 13.5433 10.7961C13.8448 10.0681 14 9.28793 14 8.5C14 7.71207 13.8448 6.93185 13.5433 6.2039C13.2417 5.47595 12.7998 4.81451 12.2426 4.25736C11.6855 3.70021 11.0241 3.25825 10.2961 2.95672C9.56815 2.65519 8.78793 2.5 8 2.5C7.21207 2.5 6.43185 2.65519 5.7039 2.95672C4.97595 3.25825 4.31451 3.70021 3.75736 4.25736C3.20021 4.81451 2.75825 5.47595 2.45672 6.2039C2.15519 6.93185 2 7.71207 2 8.5Z"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8 8.5L9.33333 10.5"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8 5.16602V8.49935"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_374_10111">
                        <rect
                          width="16"
                          height="16"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  {destinationTime && (
                    <p className="text-neutral-pure800 font-[500]">
                      Saída às {destinationTime}
                    </p>
                  )}
                </Flex>
              )}
        </Flex>
      </Flex>
    </Flex>
  );
};

interface BuscarVeiculosModalRotasProps {
  isCheckout?: boolean;
  padding?: boolean;
  title?: TabOptions;
  isItem?: boolean;
  trip?: Trip;
}

export const BuscarVeiculosModalRotas = ({
  isCheckout,
  title,
  padding = true,
  isItem,
  trip
}: BuscarVeiculosModalRotasProps) => {
  const [showAll, setShowAll] = React.useState(false);
  const { intervaloDias } = useRoteiro();
  return (
    <Flex
      className={`flex-col bg-white gap-4 pt-6 ${isItem ? 'w-full' : 'w-[296px]'}`}
    >
      {title && (
        <p
          className={`${isCheckout ? 'border-b-[1px] pb-2 border-dashed' : ''} ${padding ? 'px-6' : ''}  h5bold text-neutral-pure1000`}
        >
          {tabOptionValue[title]}
        </p>
      )}
      <Flex className="flex-col gap-4">
        {(!!intervaloDias && intervaloDias.length > 0) ||
        title === 'customtrip' ? (
          <>
            {intervaloDias.map((dia, diaIndex) => {
              if (!dia.vaiUsarVeiculoNoDia) return null;
              return (
                <Flex
                  key={`${dia.data}-${diaIndex}-${dia.destinos[0].lugarSaida}`}
                  className={padding ? 'flex-col px-6 gap-4' : 'flex-col gap-4'}
                >
                  <p className="h6bold text-neutral-pure1000">
                    {diaIndex + 1}º dia - {dia.data}
                  </p>
                  {dia.destinos.map((destino, destinoIndex) => {
                    return (
                      <Flex
                        className="flex-col gap-4"
                        key={`${destino.horarioSaida}-${destinoIndex}-${destino.lugarSaida}-${destino.lugarDestino}`}
                      >
                        {destinoIndex === 0 && (
                          <RoteiroPersonalizadoResumoOrigem
                            horarioSaída={destino.horarioSaida}
                            origem={destino.lugarSaida}
                            pontosEmbarque={destino.pontosEmbarque}
                          />
                        )}
                        <RoteiroPersonalizadoResumoDestino
                          destino={destino.lugarDestino}
                          nextStop={
                            destinoIndex + 1 < dia.destinos.length
                              ? dia.destinos[destinoIndex + 1]
                              : undefined
                          }
                        />
                      </Flex>
                    );
                  })}
                </Flex>
              );
            })}
          </>
        ) : (
          <Flex className={padding ? 'px-6' : ''}>
            <BuscarVeiculoModalOrigem trip={trip} type={title} />
          </Flex>
        )}
        {(showAll || !isCheckout) && title !== 'customtrip' && (
          <>
            <Flex className={padding ? 'flex-col px-6' : 'flex-col'}>
              <BuscarVeiculoModalDestino trip={trip} type={title} />
            </Flex>
          </>
        )}
        {isCheckout && (
          <Flex className={`${showAll ? '' : '-mt-8'} w-full bg-white`}>
            {showAll ? (
              <button
                onClick={() => setShowAll(false)}
                className="w-full p-4 border-t-[1px]"
              >
                <Flex className="gap-2 text-[color:var(--text-primary-pure)] justify-center items-center">
                  <p className="h6 text-[color:var(--text-primary-pure)] cursor-pointer">
                    Fechar detalhes da rota
                  </p>
                  <Icons.ChevronDown className="transform rotate-180" />
                </Flex>
              </button>
            ) : (
              <button
                onClick={() => setShowAll(true)}
                className="w-full p-4 border-t-[1px]"
              >
                <Flex className="gap-2 text-[color:var(--text-primary-pure)] justify-center items-center">
                  <p className="h6  cursor-pointer">Mostrar detalhes da rota</p>
                  <Icons.ChevronDown />
                </Flex>
              </button>
            )}
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};
